"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.possibleTypes = void 0;
__exportStar(require("./shared/core"), exports);
__exportStar(require("./shared/energy-provider"), exports);
__exportStar(require("./shared/api/legacy-queries"), exports);
var kapi_1 = require("./shared/api/kapi");
Object.defineProperty(exports, "possibleTypes", { enumerable: true, get: function () { return kapi_1.possibleTypes; } });
__exportStar(require("./domains/billing"), exports);
__exportStar(require("./domains/demo"), exports);
__exportStar(require("./domains/meter-reads"), exports);
__exportStar(require("./domains/transfers"), exports);
__exportStar(require("./domains/payments"), exports);
__exportStar(require("./domains/plan"), exports);
__exportStar(require("./domains/profile"), exports);
__exportStar(require("./domains/usage"), exports);
if (process.env.NODE_ENV === 'development') {
    var _a = module.require('../package.json'), name_1 = _a.name, version = _a.version;
    console.debug("".concat(name_1, "@").concat(version));
}
